import { render, staticRenderFns } from "./IndividualForeignContractorDetails.vue?vue&type=template&id=42f332e6&scoped=true&"
import script from "./IndividualForeignContractorDetails.vue?vue&type=script&lang=ts&"
export * from "./IndividualForeignContractorDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f332e6",
  null
  
)

export default component.exports